import { Z_INDEX_MAX } from '@/helpers/commonConsts'
import { ComponentFactory } from '@/mobxTools'
import { InputNumber, Modal, QRCode, Spin } from 'antd'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import style from './BuyTokenPackageDialog.module.less'
import { BuyTokenPackageDialogVm } from './BuyTokenPackageDialogVm'

/** BuyTokenPackageDialog 组件的 Props */
export type BuyTokenPackageDialogProps = {
  open: boolean
  source: string
  type: ServerDataTypes.PackagePlan['packetScene']
  onClose?: (isPaySuccessful: boolean) => void
  paySuccess?: () => void
}

/**
 * @author TODO
 * (在这里对组件进行说明)
 */
export const BuyTokenPackageDialog = ComponentFactory.createComponent(
  'BuyTokenPackageDialog',
  BuyTokenPackageDialogVm,
  (vm) => {
    const { open, onClose } = vm.props
    if (!vm.selectPlan) {
      return null
    }
    return (
      <Modal
        wrapClassName={classNames(style.buyTokenPackageDialog)}
        zIndex={Z_INDEX_MAX}
        maskClosable={false}
        open={open}
        centered
        footer={false}
        width='572px'
        getContainer={false}
        onCancel={() => {
          if (onClose) {
            onClose(false)
          }
        }}
      >
        <div className={classNames(style.buyTokenPackageContent)}>
          <p className={classNames(style.title)}>购买加量包</p>
          <div className={classNames(style.wordPackTipsBox)}>
            <img
              src='https://assets.weibanzhushou.com/web/pt-web/pay-dialog_new_icon__bell-new.210bc4422b89.png'
              className={classNames(style.bellIcon)}
            />
            <span>
              加量包中的额度一直有效，不会过期。额度包可叠加购买。额度消耗顺序为：套餐中的额度 {'>'}{' '}
              赠送的额度 {'>'} 加量包中的额度
            </span>
          </div>
          <ul className={classNames(style.wordPackPlans)}>
            {vm.packagePlans.map((plan) => {
              return <PlanItem key={plan.id} vm={vm} plan={plan}></PlanItem>
            })}
          </ul>
          <div className={classNames(style.paymentBox)}>
            <div className={classNames(style.qrBox)}>
              <img
                src='https://assets.weibanzhushou.com/web/pt-web/login-page_bg__qr.518234b9d754.png'
                className={classNames(style.qrBg)}
              />
              <Spin spinning={vm.orderCreating} size='small'>
                <QRCode
                  status={vm.orderCreating ? 'loading' : 'active'}
                  value={vm.orderQrCode}
                  size={162}
                  bordered={false}
                  style={{ padding: 0 }}
                ></QRCode>
              </Spin>
              {vm.qrErr && (
                <div
                  className={classNames(style.reloadBox)}
                  onClick={() => {
                    vm.genOrderQrCode()
                  }}
                >
                  <img src='https://assets.weibanzhushou.com/web/pt-web/icon__qr-reload.b68e5cd3c901.png' />
                  <span>刷新</span>
                </div>
              )}
            </div>
            <div className={classNames(style.right)}>
              <div className={classNames(style.channelList)}>
                <div
                  className={classNames(style.alipayBox, style.flexRow, {
                    [style.active]: vm.currentTabKey === 'alipay_qr',
                  })}
                  onClick={() => {
                    vm.currentTabKey = 'alipay_qr'
                    vm.genOrderQrCode()
                  }}
                >
                  <img src='https://assets.weibanzhushou.com/web/pt-web/ali-pay.18b4779d8424.png' />
                  <span>支付宝支付</span>
                </div>
                <div
                  className={classNames(style.wechatBox, style.flexRow, {
                    [style.active]: vm.currentTabKey === 'wx_pub_qr',
                  })}
                  onClick={() => {
                    vm.currentTabKey = 'wx_pub_qr'
                    vm.genOrderQrCode()
                  }}
                >
                  <img src='https://assets.weibanzhushou.com/web/pt-web/wechat-pay.9115a8ba339f.png' />
                  <span>微信支付</span>
                </div>
              </div>
              <div className={classNames(style.countBox)}>
                <p className={classNames(style.vipTitleBold)}>
                  加量包-{(vm.selectPlan.packetCount * vm.packageCount).toLocaleString()}{' '}
                  {vm.selectPlan.packetScene === 'ai_llm' ||
                  vm.selectPlan.packetScene === 'ai_top_llm'
                    ? 'Token'
                    : '页'}
                </p>

                <InputNumber
                  className={classNames(style.countInput)}
                  min={1}
                  max={100}
                  step={1}
                  precision={0}
                  parser={(value) => {
                    if (!value) return 1
                    // 如果包含小数点，只取小数点前的部分
                    const integerPart = value.split('.')[0]
                    // 去除非数字字符，只保留数字
                    const parsed = integerPart.replace(/[^\d]/g, '') || '1'
                    return parseInt(parsed, 10)
                  }}
                  formatter={(value) => {
                    // 确保显示整数
                    return value ? Math.floor(Number(value)).toString() : '1'
                  }}
                  addonBefore={
                    <span
                      className={classNames(style.action)}
                      onClick={() => {
                        if (vm.packageCount > 1) {
                          vm.packageCount--
                          vm.debounceGenOrderQrCode()
                        }
                      }}
                    >
                      -
                    </span>
                  }
                  addonAfter={
                    <span
                      className={classNames(style.action)}
                      onClick={() => {
                        if (vm.packageCount < 100) {
                          vm.packageCount++
                          vm.debounceGenOrderQrCode()
                        }
                      }}
                    >
                      +
                    </span>
                  }
                  value={vm.packageCount}
                  size='small'
                  onChange={(value) => {
                    if (value === null || value < 1) {
                      vm.packageCount = 1
                    } else if (value > 100) {
                      vm.packageCount = 100
                    } else {
                      vm.packageCount = Math.floor(Number(value))
                    }
                    vm.debounceGenOrderQrCode()
                  }}
                  controls={false}
                />
              </div>

              <p className={classNames(style.vipTotal)}>
                ￥{Math.floor((vm.selectPlan.packetPrice / 100) * vm.packageCount)}
              </p>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
)

const PlanItem = observer(
  ({ vm, plan }: { vm: BuyTokenPackageDialogVm; plan: ServerDataTypes.PackagePlan }) => {
    const packageName = (packageType: ServerDataTypes.PackagePlan['packetScene']) => {
      if (packageType === 'pdf_pro') {
        return '页「PDF 分段翻译」解析页数'
      }
      if (packageType === 'pdf_ultra') {
        return '页「PDF 无损翻译」解析页数'
      }
      if (packageType === 'ai_llm') {
        return '「高级模型」Token'
      }
      if (packageType === 'ai_top_llm') {
        return '「顶级模型」Token'
      }
      return '-'
    }
    return (
      <li
        key={plan.id}
        className={classNames({ [style.active]: plan.id === vm.selectPlan.id })}
        onClick={() => {
          vm.selectPlan = plan
          vm.handlePriceChange()
        }}
      >
        <img
          src='https://assets.weibanzhushou.com/web/pt-web/pay-dialog_bg__token-package.bd7249ce6409.png'
          alt=''
          className={classNames(style.planActiveBg)}
        />
        <img
          src='https://assets.weibanzhushou.com/web/pt-web/pay-dialog_icon__word-count-active.e4b46358d388.png'
          className={classNames(style.iconPlanActive)}
        />
        <div className={classNames(style.selectionBoxMiddle)}>
          <span className={classNames(style.pricePrefix)}>￥</span>
          <span className={classNames(style.priceText)}>{Math.floor(plan.packetPrice / 100)}</span>
        </div>
        <div className={classNames(style.tokenCount)}>
          {plan.packetCountZh} {packageName(plan.packetScene)}
        </div>
      </li>
    )
  }
)
